import { prop, path, pick } from 'ramda';
import { getCleanUrl } from 'js/utils/url.util';
import { useAppSelector, usePageSelector, useUserSelector } from 'js/store/hooks';

import { ROOT_PATH } from '../constants';

export const useGetPagePath = () => {
    const lang = useUserSelector(prop('lang'));
    const { rootPage, defaultLocale } = useAppSelector(pick(['rootPage', 'defaultLocale']));
    const defaultPageUrl = usePageSelector(path(['url', defaultLocale]));
    const pageUrl = usePageSelector(path(['url', lang])) || defaultPageUrl;

    return pageUrl === rootPage && getCleanUrl() === ROOT_PATH ? ROOT_PATH : pageUrl;
};
